import { render, staticRenderFns } from "./Registries.vue?vue&type=template&id=992e9c1c"
import script from "./Registries.vue?vue&type=script&lang=js"
export * from "./Registries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports